<template lang="pug">
component(:is='currentRole.type')
</template>

<script>
import "./scss/index";

export default {
  name: "TimesheetDetail",
  components: {
    RecruitmentAgencyAdministrationRole: () => import("./RecruitmentAgencyAdministrationRole/Index.vue"),
    ContractingRole: () => import("./ContractingRole/Index.vue"),
    AuthorisingRole: () => import("./AuthorisingRole/Index.vue"),
  },
};
</script>
